/**

 * Helper to measure stuff on possibly hidden nodes
 * This only works with block elements, since there
 * a) is no way to reset a style to a browser default
 * b) we don't know if a tag should be inline or block
 * c) doesn't make much sense on non block nodes anyway

 */

/* jslint plusplus: true */
/* globals jQuery, window, document */
/* exported jQuery, window, document */
(function (jQuery, window, document) {

	'use strict';

	// show the given nodes to do some measuring
	// the function will be called when node is showed
	// afterwards we will revert changed view states
	// fn is mandatory and must be synchronous
	jQuery.fn.showToMeasure = function (fn) {

		// closure variables
		var treenodes = [],
		    viewstate = [];

		// closure to reset states
		function revert () {
			for (var i = 0, L = viewstate.length; i < L; i++) {
				viewstate[i][0].css('display', viewstate[i][1]);
			}
		}

		// now show all nodes
		this.each(function(n, node) {
			// show temporarily
			// if (jQuery(node).is(':hidden')) {
			if (node.offsetParent === null) {
				// move up to the body tag
				while (node.tagName != 'BODY') {
					// collect view states
					treenodes.push(jQuery(node));
					// move up in the tree
					node = node.parentNode;
				}
				// process the array from behind
				// basically starting at the tree top
				// so we only change actual hidden nodes
				var i = treenodes.length; while (i--) {
					// this is a jQuery node
					var $treenode = treenodes[i];
					// check if the current node is hidden
					if ($treenode.is(':hidden')) {
						// store the old state for node to be changed
						viewstate.push([$treenode, $treenode[0].style.display]);
						// forcefully display this node now
						$treenode.css('display', 'block');
					}
				}
			}
		});

		// call function
		fn.call(this);
		// revert visibility
		revert.call(this);
		// keep chainable
		return this;

	};

})(jQuery, window, document);




//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/utils/jquery.showtomeasure.js
// module id = 74
// module chunks = 0